exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */:host{display:flex;flex-direction:row;z-index:1;line-height:12px;font-size:12px}.m-column{display:flex;flex-direction:column}.m-column:not(:first-child){margin-left:20px}.m-cell{display:flex;flex-direction:row}.m-cell:not(:first-child){margin-top:10px}.m-cell-sample{width:24px;height:12px;margin-right:6px}.m-cell-label{white-space:nowrap}", ""]);

// exports
